import React, { memo, forwardRef } from "react";
const SvgNotEqualTo = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M10.268 24.507a1 1 0 001.732 1l2.387-4.134h9.327c.71 0 1.286-.447 1.286-1 0-.552-.576-1-1.286-1h-8.172l3.464-6h4.708c.71 0 1.286-.447 1.286-1 0-.552-.576-1-1.286-1H20.16L22 8.188a1 1 0 10-1.732-1l-2.417 4.186H8.286c-.71 0-1.286.448-1.286 1 0 .553.576 1 1.286 1h8.41l-3.464 6H8.286c-.71 0-1.286.448-1.286 1 0 .553.576 1 1.286 1h3.791l-1.81 3.134z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgNotEqualTo.displayName = "SvgNotEqualTo";
const MemoForwardRef = memo(SvgNotEqualTo);
export default MemoForwardRef;
